(() => {
  'use strict';
  const config = document.querySelector('[data-rw-cart-cleanup]');
  if (!config || window.rwCleanRetiredCartData) return;
  const root = config.dataset.root;
  const retired = key => /lool/i.test(key) || key === 'frameProps';
  const fixedKeys = ['__loolKey', '__loolSession', '__loolPx', 'frameProps'];
  let pending;
  async function readCart() {
    const response = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error(config.dataset.error);
    return response.json();
  }
  function hasLegacyPair(cart) {
    return cart.items.some(item => Object.keys(item.properties || {}).some(key => /lool/i.test(key)));
  }
  async function clean() {
    const cart = await readCart();
    const keys = new Set([...fixedKeys, ...Object.keys(cart.attributes || {}).filter(retired)]);
    const attributes = Object.fromEntries([...keys].map(key => [key, '']));
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes})
    });
    if (!response.ok) throw new Error(config.dataset.error);
    const updated = await response.json();
    if (Object.entries(updated.attributes || {}).some(([key, value]) => retired(key) && value)) {
      throw new Error(config.dataset.error);
    }
    return updated;
  }
  window.rwCleanRetiredCartData = () => {
    if (!pending) pending = clean().finally(() => { pending = null; });
    return pending;
  };
  async function readyForCheckout() {
    const cart = await window.rwCleanRetiredCartData();
    if (hasLegacyPair(cart)) throw new Error(config.dataset.legacy);
  }
  function showError(error, target) {
    let message = document.getElementById('rw-cart-cleanup-error');
    if (!message) {
      message = document.createElement('p');
      message.id = 'rw-cart-cleanup-error';
      message.setAttribute('role', 'alert');
      message.tabIndex = -1;
      (target?.closest('form') || document.querySelector('main') || document.body).append(message);
    }
    message.textContent = error.message || config.dataset.error;
    message.focus();
  }
  let submitting = false;
  document.addEventListener('submit', event => {
    const form = event.target;
    const action = new URL(form.action, location.href);
    const checkout = event.submitter?.name === 'checkout' || /\/checkout\/?$/.test(action.pathname);
    if (!checkout || action.origin !== location.origin) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitting) return;
    submitting = true;
    const button = event.submitter;
    if (button) button.disabled = true;
    readyForCheckout().then(() => {
      if (button?.name === 'checkout') {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'checkout'; input.value = button.value || 'Checkout';
        form.append(input);
      }
      HTMLFormElement.prototype.submit.call(form);
    }).catch(error => {
      submitting = false;
      if (button) button.disabled = false;
      showError(error, form);
    });
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/checkout(?:\/|$)/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitting) return;
    submitting = true;
    readyForCheckout().then(() => location.assign(url.href)).catch(error => {
      submitting = false;
      showError(error, link);
    });
  }, true);
  window.rwCleanRetiredCartData().catch(() => {});
})();
